<template>
	<div id="volume-slider" class="tw-flex tw-items-center volume-slider-container tw-ml-2">
		<i class="tw-cursor-pointer" :class="[is_muted ? 'fa-volume-slash muted' : 'fa-volume fa-lg tw-text-white', 'fas tw-mr-2']" @click="is_muted ? unmute() : mute()"/>
		<input v-model="live_room.volume" ref="slider" type="range" id="volume-slider-input" name="volume-slider-input" min="0" max="100" class="slider"/>
	</div>
</template>

<script>
// So the value of a range input is a DOMString, that's why we use a string throughout this component instead of a number.
// Could cast everything but thought it was a better idea to just go with the HTML specs.
export default {
	name: "VolumeSlider.vue",
	watch: {
        'live_room.volume'(new_volume, old_volume) {
          if (old_volume !== new_volume) {
            this.$refs.slider.style.background = 'linear-gradient(to right, #FFF 0%, #FFF ' + this.live_room.volume + '%, #8D8D8D ' + this.live_room.volume + '%, #8D8D8D 100%)';
          }
        },
	},
	props: {
		live_room: {
			type: Object,
			required: true,
		}
	},
	computed: {
		is_muted(){
			return this.live_room.volume === '0';
		}
	},
	methods: {
		unmute(){
			this.live_room.volume = '30';
		},
		mute() {
      this.live_room.volume = '0';
		}
	},
}
</script>

<style scoped>
.muted {
	color: rgba(255, 255, 255, 0.3);
}
.icon {
	font-size: 0.925em;
}
.slider {
	margin: 0 !important;
	padding: 0 !important;
	border: 0 !important;
}
.volume-slider-container {
	padding: 8px 4px;
	border-radius: 4px;
}
/* TODO: check different browsers since inputs are rendered different */
input[type=range] {
	background: linear-gradient(to right, #FFF 0%, #FFF 50%, #8D8D8D 50%, #8D8D8D 100%);
	transition: background 450ms ease-in;
	-webkit-appearance: none; /* Hides the slider so that custom slider can be made */
}
input[type=range]::-webkit-slider-runnable-track {
	height: 4px;
	border-radius: 4px;
}
input[type=range]::-webkit-slider-thumb {
	height: 1.143rem;
	width: 1.143rem;
	background-color: white;
	border-radius: 9999px;
	cursor: pointer;
	-webkit-appearance: none;
	margin-top: calc((1.143rem - 4px) / -2);
}
</style>
